export class MusicTranscriptionWorkerController {
  private worker: Worker | null;

  constructor(callback: (event: MessageEvent<any>) => void) {
    this.worker = new Worker('./MusicTranscriptionWorker.ts', {type: 'module'});
    this.worker.addEventListener("message", (event) => {
      callback(event);
    })
  }

  public post(type: string, data: any) {
    this.worker?.postMessage({type, data});
  }

  public terminate(): void {
    if (this.worker) {
      this.worker.terminate();
      this.worker = null;
    }
  }
}